import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';
import { MessageService } from '../services/message.service';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss'],
})

export class UsersListComponent implements OnInit {

  url: string       = 'users';

  data: Array<any>  = [];

  constructor(
    private dataService: DataService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.dataService.getData(this.url).subscribe(response => {
      console.log('list users ',response)
      this.data = response.data;
    });
  }

  deleteData(id: string): void {
    if (!confirm('Desea eliminar el registro?')) {
      return;
    }

    this.dataService.deleteData(`${this.url}/delete/${id}`).subscribe(response => {

      if (response.rst) {
        this.messageService.add(response.msg, 'info');
      } else {
        this.messageService.add(response.msg, 'secondary');
      }

      this.getData();
    });
  }
} 
